import { isFeatureEnabled } from 'owa-feature-flags';
import { FilePickerAction, FileProviderItemViewState, SelectedFilesSource } from 'owa-filepicker';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { CreateAttachmentHandler } from '../../types/CreateAttachmentHandler';
import { InsertLinkHandler } from '../../types/InsertLinkHandler';
import {
    onCloudFilesSelected,
    onLocalFilesSelected,
    onRecentAttachmentFilesSelected,
} from '../../utils/onFilesSelected';
import { onFilesSelectedForInsert } from '../../utils/onFilesSelectedForInsert';

function shouldInsertAsLink(
    supportsInsertLink: boolean,
    action: FilePickerAction,
    fileProviderType: AttachmentDataProviderType
): boolean {
    if (!supportsInsertLink) {
        return false;
    }
    // In this experiment, we split share/insert so that share (as cloud attachment) and insert link are seperate actions
    if (
        fileProviderType === AttachmentDataProviderType.OneDrivePro &&
        (isFeatureEnabled('doc-insertLink-shareInsertAttach') ||
            isFeatureEnabled('doc-insertLink-insertShareAttach'))
    ) {
        return action === FilePickerAction.InsertAsLink;
    }
    // otherwise, the share button either do 'share as cloud attachment', or, 'insert link into body' depending on doc-link-filePicker
    else {
        if (action === FilePickerAction.Share) {
            return isFeatureEnabled('doc-link-filePicker');
        }
        return false;
    }
}

export function attachFilesForSelectedAction(
    createAttachmentHandler: CreateAttachmentHandler,
    insertLinkHandler: InsertLinkHandler,
    selectedFiles: File[] | FileProviderItemViewState[],
    source: SelectedFilesSource,
    action: FilePickerAction,
    supportsInsertLink: boolean
) {
    if (source === SelectedFilesSource.LocalComputerFiles) {
        onLocalFilesSelected(
            createAttachmentHandler,
            <File[]>selectedFiles,
            action === FilePickerAction.Insert,
            action === FilePickerAction.Share
        );
    } else if (source === SelectedFilesSource.ProviderFiles) {
        const itemViewState: FileProviderItemViewState = selectedFiles[0] as FileProviderItemViewState;
        const fileProviderType: AttachmentDataProviderType = itemViewState.model.ProviderType;

        // insert link into body
        if (insertLinkHandler && shouldInsertAsLink(supportsInsertLink, action, fileProviderType)) {
            onFilesSelectedForInsert(insertLinkHandler, selectedFiles, source);
        } else {
            const files = <FileProviderItemViewState[]>selectedFiles;
            // Attach as copy or share
            if (action !== FilePickerAction.AttachAndShare) {
                onCloudFilesSelected(
                    createAttachmentHandler,
                    files,
                    action === FilePickerAction.Share
                );
            } else {
                // attach and share
                onRecentAttachmentFilesSelected(createAttachmentHandler, files);
            }
        }
    }
}
